var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaestro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0949 7.12711C14.0949 10.9395 11.0398 14.0301 7.27116 14.0301C3.50249 14.0301 0.447388 10.9395 0.447388 7.12711C0.447388 3.31469 3.50249 0.224121 7.27116 0.224121C11.0398 0.224121 14.0949 3.31469 14.0949 7.12711Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9473 7.12711C22.9473 10.9395 19.8922 14.0301 16.1236 14.0301C12.3549 14.0301 9.2998 10.9395 9.2998 7.12711C9.2998 3.31469 12.3549 0.224121 16.1236 0.224121C19.8922 0.224121 22.9473 3.31469 22.9473 7.12711Z",
    fill: "#0099DF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6974 1.87305C13.1646 3.13918 14.0949 5.02317 14.0949 7.12697C14.0949 9.23077 13.1646 11.1148 11.6974 12.3809C10.2303 11.1148 9.29993 9.23077 9.29993 7.12697C9.29993 5.02317 10.2303 3.13918 11.6974 1.87305Z",
    fill: "#6C6BBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaestro);
export default __webpack_public_path__ + "static/media/maestro.3df4b511bb0de37866d6a7ffa8271f46.svg";
export { ForwardRef as ReactComponent };